import { action } from "satcheljs";
import { IOpenShiftEntity, OpenShiftEntity } from "sh-models";
import { IPreviewSchedulePageStore } from "../../../sh-application/components/previewSchedulePage";
import { SchedulesViewStateStore } from "../../../sh-application/components/schedules/lib/store/schema/SchedulesViewStateStore";

const deleteOpenShiftsInStore = action(
    "DELETE_OPENSHIFTS_IN_STORE",
    (
        deletedOpenShifts: IOpenShiftEntity[],
        viewState?: IPreviewSchedulePageStore | SchedulesViewStateStore
    ) => ({
        // We use clones of the argument entities. This is because setting the entities in the satchel stores will mark them as observables
        // and any callers who still hold references to these entities will not be able to mutate them (in event of an error, for example) without
        // triggering mobx exceptions
        deletedOpenShifts: deletedOpenShifts ? deletedOpenShifts.map(openShift => OpenShiftEntity.clone(openShift)) : [],
        viewState: viewState
    })
);

export default deleteOpenShiftsInStore;
